<template>
  <div class="ts-p-3">
    <h6
      class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md"
      style="width:fit-content"
    >{{ $t('promotion.condition') }}</h6>
    <table class="ts-w-full table">
      <thead>
        <tr>
          <th class="ts-w-32">{{ $t('promotion.description') }}</th>
          <th class="ts-w-64">{{ $t('promotion.sign') }}</th>
          <th class="ts-w-40">{{ $t('promotion.amountFrom') }}</th>
          <th class="ts-w-40">{{ $t('promotion.amountTo') }}</th>
          <th>{{ $t('promotion.coinEarnded') }}</th>
          <th class="ts-w-1">
            <a href="#" @click.prevent="addItem">
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(con, index) in model.condition" :key="index">
          <td valign="middle">Sale Volume</td>
          <td>
            <select 
              v-model="con.operator_sign" 
              class="form-control"
              @change="operatorChange(con)"
            >
              <option value="=">Equal</option>
              <option value="between">Between</option>
              <option value=">=">Greater or equal</option>
            </select>
            <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.operator_sign')">
              {{ errors.first('condition.' + index + '.operator_sign') }}
            </div>
          </td>
          <td>
            <input 
              v-model.number="con.amount_from" 
              type="number" 
              step="any" class="form-control" 
            />
            <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.amount_from')">
              {{ errors.first('condition.' + index + '.amount_from') }}
            </div>
          </td>
          <td>
            <input
              v-model.number="con.amount_to"
              type="number"
              step="any"
              :disabled="con.operator_sign != 'between'"
              class="form-control"
            />
            <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.amount_to')">
              {{ errors.first('condition.' + index + '.amount_to') }}
            </div>            
          </td>
          <td>
            <input 
              v-model.number="con.coin_earned" 
              type="number" 
              step="any" class="form-control"
							style="width:200px" 
            />
            <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.coin_earned')">
              {{ errors.first('condition.' + index + '.coin_earned') }}
            </div>
          </td>
          <td>
            <a
              href="#"
              class="ts-text-red-700 hover:ts-text-red-700"
              @click.prevent="removeItem(index)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'freeCoinCondition',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      errors: new Errors(),
      row: {
        operator_sign: "=",
        amount_from: null,
        amount_to: null,
        coin_earned: null
      }
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    addItem() {
      this.model.condition.push(_.cloneDeep(this.row))
    },
    removeItem(index) {
      this.model.condition.splice(index, 1)
    },
    operatorChange(row){
      if(row.operator_sign != 'between'){
        row.amount_to = null
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
